import {z} from 'zod';
export const PublicPaymentMethodsSchema=z.object({card:z.boolean(),cryptoAssetIds:z.array(z.string())}).strict();
export type PublicPaymentMethods=z.infer<typeof PublicPaymentMethodsSchema>;
